const CAMPUS_LAT = 41.6611;
const CAMPUS_LNG = -91.5302;
const WALK_SPEED_MPH = 3;

// Haversine formula — returns distance in miles
export function distanceFromCampus(lat, lng) {
  const R = 3958.8; // Earth radius in miles
  const dLat = ((lat - CAMPUS_LAT) * Math.PI) / 180;
  const dLng = ((lng - CAMPUS_LNG) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((CAMPUS_LAT * Math.PI) / 180) *
      Math.cos((lat * Math.PI) / 180) *
      Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.asin(Math.sqrt(a));
}

// Returns "X min walk" string, or null if > 1 mile or no coordinates
export function walkingTime(lat, lng) {
  if (lat == null || lng == null) return null;
  const miles = distanceFromCampus(lat, lng);
  if (miles > 1) return null;
  const minutes = Math.round((miles / WALK_SPEED_MPH) * 60);
  return `${minutes} min walk`;
}
